module.exports = __webpack_public_path__ + "img/1.05a9f0cf.png";